// Base URL of the Azure Functions backend, shared by the API client and analytics.
export const API_BASE_URL = process.env.REACT_APP_TEASER_API_URL || "http://localhost:7071/api";
